import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Image, UIHeading4, UIText2, Button } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './HintQuestionBanner.css';

type THintQuestionBannerProps = {
  title: string;
  description: string;
  iconUrl?: string | null;
  primaryButtonText: string;
  secondaryButtonText: string;
  isMobile: boolean;
  onPrimaryButtonClick(): void;
  onSecondaryButtonClick(): void;
  onShow(): void;
};

export const HintQuestionBanner: React.FC<THintQuestionBannerProps> = ({
  title,
  description,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onShow,
  primaryButtonText,
  secondaryButtonText,
  iconUrl,
  isMobile,
}) => (
  <ActionAfterViewObserver percentVisible={0.5} callback={onShow} triggerOnce>
    <div data-name="HintQuestionBanner" className={classNames(styles['container'], isMobile && styles['phone'])}>
      {isMobile && iconUrl && <Image src={iconUrl} alt="Иконка баннера" width={40} height={40} borderRadius={0} />}
      <div className={styles['text']}>
        <UIHeading4>{title}</UIHeading4>
        <UIText2 textAlign="center">{description}</UIText2>
      </div>
      <div className={styles['buttons']}>
        <Button onClick={onPrimaryButtonClick} theme="fill_primary">
          {primaryButtonText}
        </Button>
        <Button onClick={onSecondaryButtonClick} theme="fill_white_primary">
          {secondaryButtonText}
        </Button>
      </div>
    </div>
  </ActionAfterViewObserver>
);
